<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <futurocoin-stats></futurocoin-stats>
        <futurocoin-history-table></futurocoin-history-table>
        <router-link :to="{ name: 'Futurocoin' }"
                     class="button--secondary"
                     style="margin-top: 24px;"><i class="mdi mdi-chevron-left"></i> Back to Futurocoin</router-link>
    </b-col>
</template>

<script>
    import FuturocoinStats from './futurocoin/FuturocoinStats.vue'
    import FuturocoinHistoryTable from './futurocoin-history/FuturocoinHistoryTable.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'

    export default {
        dependencies: ['ftoAccounts'],
        components: { FuturocoinStats, FuturocoinHistoryTable, FuturocoinsFromMining },
        computed: {
            mining () {
                return this.$store.getters.ftoAccounts.miningAccount
            },
            royalPosition () {
                return this.$store.getters.ftoAccounts.royalBonusAccount
            }
        },
        created () {
            this.$store.dispatch('loadDailyMining')
            this.$store.dispatch('loadFuturocoinWithdraw')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/FuturocoinHistoryContent.vue